import React from "react";

const DeleteAccountInstructions = () => {
  return (
    <div style={{ fontFamily: "Arial, sans-serif", margin: "20px", padding: "20px", border: "1px solid #ccc", borderRadius: "10px" }}>
      <h1 style={{ textAlign: "center", color: "#333" }}>How to Delete Your TR Gate Home Account</h1>
      <p style={{ fontSize: "18px", lineHeight: "1.6", marginBottom: "20px" }}>
        Follow these steps to delete your account and remove all associated data, including your name, phone number, and profile picture:
      </p>
      <div style={{ lineHeight: "1.8", fontSize: "18px" }}>
        <h2>Step 1: Open the TR Gate Home App</h2>
        <p>Log in to your account if you haven’t already.</p>
        <p>
          Navigate to the <strong>My Account</strong> section by clicking on the profile icon in the bottom-right corner of the home screen.
        </p>

        <h2>Step 2: Access Account Details</h2>
        <p>Tap on <strong>My Details</strong> from the menu.</p>
        <p>Here, you can review and edit your personal information.</p>

        <h2>Step 3: Delete Your Account</h2>
        <p>Scroll to the bottom of the <strong>My Details</strong> page.</p>
        <p>Click on the <strong>Delete Account</strong> button.</p>
        <p>Confirm your choice when prompted.</p>

        <h2>Step 4: Data Deletion Confirmation</h2>
        <p>
          Once you delete your account, your personal data, including your name, phone number, and uploaded profile picture, will be permanently removed from our system.
        </p>
        <p>You will no longer have access to the app or any previously saved information.</p>
      </div>
    </div>
  );
};

export default DeleteAccountInstructions;
